<div class="centered-content">
  <div class="card mb-4">
    <div class="card-header">
      <a routerLink="/login" class="btn btn-light btn-sm">
        <fa-icon [icon]="faArrowLeft"></fa-icon>
        <span [innerText]="'GENERAL.BACK' | translate"></span>
      </a>
    </div>
    <div class="card-body">
      <h4 [innerText]="'AUTH.FORGOT_PASSWORD_TITLE' | translate"></h4>
      <p class="mb-4" [innerText]="'AUTH.FORGOT_PASSWORD_HELP' | translate"></p>

      <form (ngSubmit)="submitForm()" [formGroup]="form" (keydown.enter)="submitForm()">
        <div class="form-group">
          <label class="form-label" [innerText]="'EMAIL' | translate"></label>
          <input
            tabindex="1"
            type="email"
            class="form-control"
            formControlName="email"
            placeholder="email@email.com"
            [class.is-invalid]="email.invalid && (email.dirty || email.touched)"
            />
          @if (email.dirty && email.errors) {
            <div class="invalid-tooltip">
              @if (email.errors && email.errors['required']) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
              @if (email.errors && email.errors['email']) {
                <div [innerText]="'FORM_VALIDATIONS.VALID_EMAIL' | translate"></div>
              }
            </div>
          }
        </div>

        <button
          class="w-100 btn btn-lg btn-primary mt-2"
          type="submit"
          [disabled]="form.disabled || !form.valid"
          (click)="submitForm()"
          tabindex="5"
          [innerText]="'GENERAL.SEND' | translate"
        ></button>
      </form>
    </div>
  </div>
</div>
